export enum ChannelSource {
  FRIENDS_FAMILY = 'Friends / Family',
  ONLINE = 'Online',
  AGENTS = 'Agents',
  OTHERS = 'Others'
}
